import { designTokens } from '@project44/manifest-ds';

export const skeletonColors = {
  primary: designTokens.colorPaletteGrey200,
  secondary: designTokens.colorPaletteGrey100,
  tertiary: designTokens.colorPaletteGrey300,
};
